import { render, staticRenderFns } from "./examDetails.vue?vue&type=template&id=4acd131a&scoped=true&"
import script from "./examDetails.vue?vue&type=script&lang=js&"
export * from "./examDetails.vue?vue&type=script&lang=js&"
import style0 from "./examDetails.vue?vue&type=style&index=0&id=4acd131a&prod&lang=css&"
import style1 from "./examDetails.vue?vue&type=style&index=1&id=4acd131a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd131a",
  null
  
)

export default component.exports